import { useQuery } from '@tanstack/react-query';
import { getHourlyPooledRule } from '../lib/apiClient';

// Settles at most three times an hour; no need to poll faster.
const STALE_TIME_MS = 5 * 60_000;

/** Forward paper test of the pooled hourly rule. Hypothetical only. */
export function useHourlyPooledRule() {
  return useQuery({
    queryKey: ['hourly-pooled-rule'],
    queryFn: getHourlyPooledRule,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
